import notificationGroupsService from '@/api/notificationgroups'
import { NOTIFICATION_GROUPS } from '../types'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    groups: [],
    availablePlaces: [],
    availableUsers: [],
    id: null,
    groupName: '',
    groupType: 'serviceDesk',
    selectedPlaces: [],
    selectedUsers: [],
  },
  getters: {
    groupName (state) {
      return state.groupName
    },
    groupType (state) {
      return state.groupType
    },    
    selectedPlaces (state) {
      return state.selectedPlaces
    },
    selectedUsers (state) {
      return state.selectedUsers
    }
  },
  mutations: {
    [NOTIFICATION_GROUPS.SET_GROUPS] (state, groups) {
      state.groups = groups
    },    
    [NOTIFICATION_GROUPS.SET_PLACES] (state, availablePlaces) {
      state.availablePlaces = availablePlaces
    },
    [NOTIFICATION_GROUPS.SET_USERS] (state, availableUsers) {
      state.availableUsers = availableUsers
    },
    [NOTIFICATION_GROUPS.SET_ID] (state, id) {
      state.id = id
    },
    [NOTIFICATION_GROUPS.SET_GROUP_NAME] (state, groupName) {
      state.groupName = groupName
    },
    [NOTIFICATION_GROUPS.SET_GROUP_TYPE] (state, groupType) {
      state.groupType = groupType
    },
    [NOTIFICATION_GROUPS.SET_PLACES_SELECTED] (state, selectedPlaces) {
      state.selectedPlaces = selectedPlaces
    },
    [NOTIFICATION_GROUPS.SET_USERS_SELECTED] (state, selectedUsers) {
      state.selectedUsers = selectedUsers
    },
  },
  actions: {
    async getNotificationGroups ({commit, dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let response = await notificationGroupsService.getNotificationGroups()
        commit(NOTIFICATION_GROUPS.SET_GROUPS, response.data)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getAvailablePlaces ({commit}, groupType) {
      let response = await notificationGroupsService.getAvailablePlaces(groupType)
      commit(NOTIFICATION_GROUPS.SET_PLACES, response.data)
    },
    async getAvailableUsers ({commit}, groupType) {
      let response = await notificationGroupsService.getAvailableUsers(groupType)
      let responseMap = response.data.map((user)=>{
        return {
          id: user.id ?? user.email,
          name: user.name,
          email: user.email
        }
      })
      commit(NOTIFICATION_GROUPS.SET_USERS, responseMap)
    },
    async saveGroup ({dispatch, state}) {
      let group = null
      if (state.groupType === strings.notificationGroupType.serviceDesk) {
        group = {
          id: state.id,
          name: state.groupName,
          type: state.groupType,
          locationIds: state.selectedPlaces.map((selectedPlaces)=>{
            return selectedPlaces.id
          }),
          userIds: state.selectedUsers.map((selectedUser)=>{
            return selectedUser.id
          }),
        }
      } else {
        group = {
          id: state.id,
          name: state.groupName,
          notificationGroupType: state.groupType,
          rooms: state.selectedPlaces,
          users: state.selectedUsers
        }
      }
      dispatch('Global/showLoading', null, {root: true})
      try {
        await notificationGroupsService.saveGroup(group)
        await dispatch('getNotificationGroups')
        dispatch('Global/showMessage', group.id ? 'editGroupSuccessfully' : 'addGroupSuccessfully', {root: true})
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }

    },
    async deleteGroup({dispatch}, group) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await notificationGroupsService.deleteGroup(group.id)
        await dispatch('getNotificationGroups')
        dispatch('Global/showMessage', 'removeGroupSuccessfully', {root: true})
      } catch(error) {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    setId({commit}, id){
      commit(NOTIFICATION_GROUPS.SET_ID, id)
    },
    setGroupName({commit}, groupName){
      commit(NOTIFICATION_GROUPS.SET_GROUP_NAME, groupName)
    },
    setGroupType({commit}, groupType){
      commit(NOTIFICATION_GROUPS.SET_GROUP_TYPE, groupType)
    },
    setSelectedPlaces({commit}, selectedPlaces){
      commit(NOTIFICATION_GROUPS.SET_PLACES_SELECTED, selectedPlaces)
    },
    setSelectedUsers({commit}, selectedUsers){
      commit(NOTIFICATION_GROUPS.SET_USERS_SELECTED, selectedUsers)
    },
    resetCreateGroup({dispatch}){
      dispatch('setId', null)
      dispatch('setGroupName', '')
      dispatch('setGroupType', 'serviceDesk')
      dispatch('selectedPlaces', [])
      dispatch('setSelectedUsers', [])
    }
  }
}
